import { createRoot } from "react-dom/client"
import App from "../App"
import * as Sentry from "@sentry/react"
import { ensurePosthogInitialized } from "../src/analytics/posthogClient.web"
import { sentryDsns } from "../src/constants"
import { attachPosthogReplayToSentryEvent } from "../src/utils/sentryPosthog.web"
import { sentryWebIgnoreErrorPatterns } from "../src/utils/sentryWebIgnoreErrors"
import { capturePlaidOAuthReturnUri } from "../src/utils/plaidOAuthResume.web"

capturePlaidOAuthReturnUri(window.location.href)
ensurePosthogInitialized()

Sentry.init({
  dsn: sentryDsns.web,
  tracesSampleRate: 0.0,
  environment: process.env.ENVIRONMENT === "production" ? "production" : "development",
  ignoreErrors: sentryWebIgnoreErrorPatterns,
  beforeSend(event, hint) {
    const originalException = hint?.originalException

    // Check if it's an Error with a stringified JSON message
    if (
      originalException instanceof Error &&
      typeof originalException.message === "string" &&
      originalException.message.trim().startsWith("{")
    ) {
      try {
        const parsed = JSON.parse(originalException.message)

        // Attach parsed JSON as extra info
        event.extra = {
          ...(event.extra || {}),
          parsedErrorMessage: parsed,
        }
      } catch (_) {
        // Not valid JSON — do nothing
      }
    }

    return attachPosthogReplayToSentryEvent(event)
  },
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack)
  }),
  // Callback called when React catches an error in an Error Boundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
})

const container = document.getElementById("app-root")
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
})

root.render(<App />)
